export default __webpack_public_path__ + "static/media/houzz.956c98ee.png";